import mapToObject from '../util/map-to-object';

const AudienceSOVPropertiesName = [
  'AudienceImpressionShare',
  'AudienceImpressionShareLostToBudget',
  'AudienceImpressionShareLostToRank',
  'RelativeCTR',
];

function mapNameToProperty(name) {
  const map = {
    AudienceImpressionShare: 'AudienceAuctionWonPercent',
    AudienceImpressionShareLostToBudget: 'AudienceTopISLostToBudgetPercent',
    AudienceImpressionShareLostToRank: 'AudienceTopISLostToRankPercent',
  };

  return map[name] || name;
}

export default mapToObject(AudienceSOVPropertiesName, property =>
  `PerformanceMetrics/${mapNameToProperty(property)}`);
